import * as React from 'react';
import { SVGProps } from 'react';
import styled from 'styled-components';

const SVG = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8 .5a1.5 1.5 0 0 1 1.362.872l1.341 2.907 3.18.377a1.5 1.5 0 0 1 .842 2.591l-2.351 2.174.624 3.14a1.5 1.5 0 0 1-2.204 1.602L8 12.599l-2.794 1.564a1.5 1.5 0 0 1-2.204-1.601l.624-3.14-2.35-2.175a1.5 1.5 0 0 1 .841-2.59l3.18-.378 1.34-2.907A1.5 1.5 0 0 1 8 .5Z"
      fill="currentColor"
    />
  </svg>
);

const StyledSvgStar = styled(SVG)`
  font-size: ${props => (props.fontSize ? props.fontSize : '1.6rem')};
  color: ${({ color, theme }) =>
    color ? color : theme.colors.neutralColors.charcoal};
  vertical-align: middle;
  shape-rendering: inherit;
  transform: translate3d(0, 0, 0);
`;
export default StyledSvgStar;
